import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatErr } from "../lib/api";
import { Logo } from "../components/Shared";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const token = params.get("token");

  const submit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { toast.error("Passwords do not match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
    } catch (err) { toast.error(formatErr(err)); }
    setBusy(false);
  };

  return (
    <div className="p1-container flex justify-center py-16 lg:py-24" data-testid="reset-password-page">
      <div className="p1-card w-full max-w-md p-10">
        <div className="flex justify-center"><Logo /></div>
        {done ? (
          <div className="mt-8 text-center" data-testid="reset-done">
            <CheckCircle2 className="mx-auto h-14 w-14 text-emerald-700" />
            <h1 className="mt-4 font-heading text-2xl font-bold text-stone-900">Password updated</h1>
            <p className="mt-2 text-sm text-stone-600">You can now sign in with your new password.</p>
            <button onClick={() => navigate("/login")} className="p1-btn-primary mt-6 w-full" data-testid="reset-login-btn">Go to Login</button>
          </div>
        ) : (
          <>
            <h1 className="mt-6 text-center font-heading text-2xl font-bold text-stone-900">Choose a new password</h1>
            {!token && <p className="mt-2 text-center text-sm text-terracotta" data-testid="reset-no-token">This reset link is missing its token. Please request a new one.</p>}
            <form onSubmit={submit} className="mt-6 space-y-4" data-testid="reset-form">
              <div><label className="p1-label">New password (min 8 characters) *</label>
                <input type="password" className="p1-input" required minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} data-testid="reset-password-input" /></div>
              <div><label className="p1-label">Confirm new password *</label>
                <input type="password" className="p1-input" required minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm-input" /></div>
              <button type="submit" disabled={busy || !token} className="p1-btn-primary w-full disabled:opacity-40" data-testid="reset-submit">{busy ? "Updating…" : "Update Password"}</button>
            </form>
            <p className="mt-4 text-center text-sm"><Link to="/login" className="font-semibold text-emerald-900 hover:underline">← Back to Login</Link></p>
          </>
        )}
      </div>
    </div>
  );
}
